const jQ = jQuery.noConflict();

class wrapTheIframe{

	constructor(){
		this.iframe = "iframe";
	}
	wrapIframeFunc(){

		jQ(this.iframe).wrap("<div class='iframe-wrapper'></div>");		
	}

	init(){
		this.wrapIframeFunc();
	}

}

const wrapIframe = new wrapTheIframe();

export default wrapIframe;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/wrapiframe.js